import { HttpClient } from '@store/base';
import {
  GetEstimateMaterialNoticesGateway,
  GetEstimateMaterialNoticesRequest,
  GetEstimateMaterialNoticesResponse,
} from '@store/order';

/**
 * SALES-14036 — 소재고지 알림톡 링크 고지내역 조회 래퍼.
 * 현재는 변환 없이 원본 응답을 그대로 리턴한다 (Base Gateway 격리용 매핑 구간).
 * 클라이언트 전용 변환 타입이 필요해지면 이 파일에 정의한다.
 */
export class ClientGetEstimateMaterialNoticesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(
    req: GetEstimateMaterialNoticesRequest,
  ): Promise<GetEstimateMaterialNoticesResponse> {
    return await new GetEstimateMaterialNoticesGateway(this.httpClient).exec(
      req,
    );
  }
}
